import { showNotification } from './actions.any';
import { renderNotificationMessageAttachments } from './components/web/NotificationMessageAttachments';
import { NOTIFICATION_ICON, NOTIFICATION_TYPE } from './constants';
export * from './actions.any';
/**
 * Queues a message notification for display.
 *
 * @param {Object} props - The props needed to show the notification component.
 * @param {string} type - Notification type.
 * @returns {Object}
 */
export function showMessageNotification(props, type) {
    return showNotification({
        ...props,
        concatText: true,
        titleKey: 'notify.chatMessages',
        appearance: NOTIFICATION_TYPE.NORMAL,
        icon: NOTIFICATION_ICON.MESSAGE,
        description: renderNotificationMessageAttachments(props.description, props.numberOfAttachments) || props.description
    }, type);
}
